import * as React from 'react';

const OrderedListChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M7.9 9v1.8l-2.2.9h2.2V13h-4v-1.8l2.2-.9H3.9V9h4zm0 6v1.3L7 17l.9.7V19h-4v-1.3h2.2l-.9-.7.9-.7H3.9V15h4zm2.2-10h10v2h-10V5zm0 6h10v2h-10v-2zm0 6h10v2h-10v-2zM6.6 3v2.7h1.3V7h-4V5.7h1.3V4.3H3.9v-.5L5.2 3h1.4z" />
    </svg>
);

OrderedListChunkySvg.displayName = 'OrderedListChunkySvg';
export default OrderedListChunkySvg;
